export default __webpack_public_path__ + "static/hero-bg-8b75b02ae9f4dfecff9361ec9c514b51.jpg";